export default [
    {
        path: "/admin/remote-users/barcode",
        component: () => import("./Barcode.vue"),
        name: "admin-remote-user-barcode",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users",
        component: () => import("./List.vue"),
        name: "admin-remote-user",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/deleted",
        component: () => import("./Deleted.vue"),
        name: "admin-remote-user-deleted",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/create",
        component: () => import("./Create.vue"),
        name: "admin-remote-user-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/import",
        component: () => import("./Import.vue"),
        name: "admin-remote-user-import",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/sync",
        component: () => import("./Sync.vue"),
        name: "admin-remote-user-sync",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-user/:id/edit",
        component: () => import("./Edit.vue"),
        name: "admin-remote-user-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/id-card",
        component: () => import("./UserIdCard.vue"),
        name: "admin-remote-users-id-card",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/remote-users/photo-card",
        component: () => import("./UserPhotoCard.vue"),
        name: "admin-remote-users-photo-card",
        meta: {
            requiresAuth: true,
        },
    },
];
